import { Markdown, MarkdownProps } from "@wojo/ui";
import { useRouter } from "next/navigation";

export type MarkdownForNextLinksProps = MarkdownProps;

export const MarkdownForNextLinks: React.FC<MarkdownForNextLinksProps> = (
    props,
) => {
    const router = useRouter();
    return (
        <Markdown
            {...props}
            onLinkClick={(e, target) => {
                props.onLinkClick?.(e, target);
                const origin = window.location.origin;
                const isAbsoluteRootRoute =
                    target.href === origin || target.href === `${origin}/`;
                const relativeOrUnknownHref = target.href.startsWith(origin)
                    ? target.href.replace(origin, "")
                    : target.href;
                const href = isAbsoluteRootRoute ? "/" : relativeOrUnknownHref;
                if (href.startsWith("/")) {
                    e.preventDefault();
                    router.push(href);
                }
            }}
        />
    );
};
